'use strict'

export let english_endProject={
  status: {
    green: "The project delivered within tolerances",
    yellow: "The project mostly delivered within tolerances and few exception plans were needed.",
    red: "The project broke tolerances repeatedly and many exception plans were needed."
  }
}



// WEBPACK FOOTER //
// ./views/components/labels/english_endProject.js